import React, { useEffect, useState } from "react";
import { Table, Tag, Tooltip, Empty, message } from "antd";
import rewardProgramApi from "../../../api/rewardProgramApi";
import { orderStatusMeta, rewardAmountTitle, fmtMoney, fmtUnix, basisColumns } from "./reward-shared-meta";

/**
 * Bảng đơn của 1 user trong đợt — dùng cho dòng mở rộng ở tab Người tham gia.
 * Tự nạp dữ liệu khi được render (chỉ khi admin bấm mở), không kéo sẵn theo trang.
 */
function RewardUserOrdersTable({ program, userId }) {
    const programId = program.id;
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        (async () => {
            setLoading(true);
            try {
                const { data } = await rewardProgramApi.participantOrders(programId, userId);
                if (alive) setRows(data.rows || []);
            } catch {
                message.error("Không tải được đơn của user");
            } finally {
                if (alive) setLoading(false);
            }
        })();
        return () => { alive = false; };
    }, [programId, userId]);

    const STATUS_META = orderStatusMeta(program);

    const columns = [
        { title: "Đơn", dataIndex: "orderId", width: 170, ellipsis: true },
        { title: "Sàn", dataIndex: "campId", width: 90 },
        { title: "Mua lúc", dataIndex: "purchaseTime", width: 140, render: (v) => fmtUnix(v, "DD/MM HH:mm:ss") },
        { title: "Lô", dataIndex: "settleBatchDate", width: 100 },
        ...basisColumns(program),
        { title: rewardAmountTitle(program), dataIndex: "rewardAmount", width: 100, align: "right", render: fmtMoney },
        {
            title: "Trạng thái", dataIndex: "status", width: 120,
            render: (v) => <Tag color={STATUS_META[v]?.color}>{STATUS_META[v]?.label || v}</Tag>,
        },
        {
            title: "Lý do", dataIndex: "reason", ellipsis: true,
            render: (v, r) => (v ? <Tooltip title={v}>{r.reasonText || v}</Tooltip> : "—"),
        },
    ];

    if (!loading && !rows.length) {
        return <Empty description="User này chưa có đơn nào trong đợt" image={Empty.PRESENTED_IMAGE_SIMPLE} />;
    }

    return (
        <Table
            size="small"
            rowKey="id"
            loading={loading}
            dataSource={rows}
            columns={columns}
            pagination={rows.length > 20 ? { pageSize: 20, size: "small" } : false}
            scroll={{ x: "max-content" }}
        />
    );
}

export default RewardUserOrdersTable;
